module.exports = __webpack_public_path__ + "static/media/attach_file.9e3fa664.svg";